module.exports = "https://preprod.web-phone.apps.phone.com/static/media/IAB_promo_background_small.837798c3.png";